import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Confirmation from "../views/Confirmation.vue";
import Teacher from "../views/Teacher.vue";
import Admin from "../views/Admin.vue";
import Address from "../views/Address2.vue";
import Account from "../views/Account.vue";
import Password from "../views/Password.vue";
import History from "../views/History.vue";
import ExamRegistration from "../views/ExamRegistration.vue";
import CheckOut from "../views/CheckOut.vue";
import Marks from "../views/Marks.vue";
import SchoolYears from "../views/SchoolYears.vue";
import Teachers from "../views/Teachers.vue";
import Transactions from "../views/Transactions.vue";
import CreditRecords from "../views/CreditRecords.vue";
import Email from "../views/Email.vue";
import Fees from "../views/Fees.vue";
import Locations from "../views/Locations.vue";
import Reports from "../views/Reports.vue";
import PendingAccounts from "../views/PendingAccounts.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/confirmation",
    name: "Confirmation",
    component: Confirmation,
  },
  {
    path: "/teacher",
    name: "Teacher",
    component: Teacher,
    meta: {
      requiresAuth: true,
      requiresTeacher: true,
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/address",
    name: "Address",
    component: Address,
  },
  {
    path: "/account",
    name: "Account",
    component: Account,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/password/:adminParam?",
    name: "Password",
    component: Password,
    props: (r) => ({
      adminParam: r.params.adminParam,
    }),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/email/:adminParam?",
    name: "Email",
    component: Email,
    props: (r) => ({
      adminParam: r.params.adminParam,
    }),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/history/:childId",
    name: "History",
    component: History,
    props: (r) => ({ childId: parseInt(r.params.childId) }),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/examregistration/:childId",
    name: "ExamRegistration",
    component: ExamRegistration,
    props: (r) => ({ childId: parseInt(r.params.childId) }),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/checkout",
    name: "CheckOut",
    component: CheckOut,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/marks",
    name: "Marks",
    component: Marks,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/schoolyears",
    name: "SchoolYears",
    component: SchoolYears,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/teachers",
    name: "Teachers",
    component: Teachers,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/fees",
    name: "Fees",
    component: Fees,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/locations",
    name: "Locations",
    component: Locations,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/pendingaccounts",
    name: "PendingAccounts",
    component: PendingAccounts,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/transactions",
    name: "Transactions",
    component: Transactions,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/creditrecords",
    name: "CreditRecords",
    component: CreditRecords,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/developer",
    name: "Developer",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Developer.vue"),
  },

  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("beforeEach", to);
  console.log("store.state.user", store.state.user);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.name === "Home" && store.state.user.accountType == 2) {
        console.log("im a teacher");
        next({ name: "Teacher" });
      } else if (
        to.matched.some((record) => record.meta.requiresTeacher) &&
        store.state.user.accountType == 1
      ) {
        console.log("im rejected from teacher");
        next(false);
      } else if (
        to.matched.some((record) => record.meta.requiresAdmin) &&
        store.state.user.accountType != 3
      ) {
        console.log("im rejected from admin");
        next(false);
      } else if (
        (to.name === "ExamRegistration" || to.name === "CheckOut") &&
        store.state.user.accountType == 1 &&
        !store.state.schoolYear
      ) {
        console.log("rejected: no schoolyear");
        next(false);
      } else {
        next();
      }
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

export default router;
